import { buildChildrenEffizienznetzwerkDokumentenablageGebaeude, buildChildrenZusatztoolsDokumentenablageGebaeude } from '../informationen_hilfe/sitemap/buildChildren'
import { ContextService } from '../../services/context_service';
import { DateiablageGalerie } from './DateiablageGalerie';
import { i18n } from '../../i18n/i18n';
import { lazyInject } from '../../services/inversify';
import * as React from 'react';
import { RoutingIDs } from '../../helpers/RoutingIDs';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import '../../css/tabs.css';

interface DateiablageGebaeudeProps extends React.ClassAttributes<any> {
    data: any;
    routing: any;
    onRoutingChange: (routing: any) => void;
    tabsClassName?: string;
    viewNotice?: JSX.Element;
}

interface DateiablageGebaeudeState {
    tabIndex: number;
}

export class DateiablageGebaeude extends React.Component<DateiablageGebaeudeProps, DateiablageGebaeudeState> {

    constructor(props: any) {
        super(props);
        this.state = {
            tabIndex: this.contextService.get('tabIdxDateiablageGebaeude') || 0
        };
    }

    @lazyInject(ContextService) private contextService: ContextService;

    componentDidMount(): void {
        this.checkRouting();
    }

    componentDidUpdate(prevProps: any) {
        if (this.props.routing !== prevProps.routing) {
            this.checkRouting();
        }
    }

    checkRouting(): void {
        const routing: any = this.props.routing || {};
        const tabName: string = this.props.tabsClassName === 'tabs-effizienznetzwerk'
            // ? RoutingIDs.TABS_EFFIZIENZNETZWERK_DOKUMENTENABLAGE_GEBAEUDE
            ? RoutingIDs.TABS_ZUSATZTOOLS_EFFIZIENZNETZWERK_DOKUMENTENABLAGE_GEBAEUDE
            : (this.props.tabsClassName === 'tabs-zusatztools' ? RoutingIDs.TABS_ZUSATZTOOLS_DOKUMENTENABLAGE_GEBAEUDE : undefined);
        if (routing.path && routing.path[tabName] !== undefined) {
            // if ((routing.path.terminateOn || null) === tabName) {
            //     this.props.onRoutingChange({});
            // }
            // this.setTabIndex(routing.path[tabName], routing);
            if (this.state.tabIndex === routing.path[tabName]) {
                if (routing.path.terminateOn === tabName) {
                    this.props.onRoutingChange({});
                }
            } else {
                this.setTabIndex(routing.path[tabName], routing);
            }
        }
    }

    setTabIndex(tabIndex: number, tabRouting: any, callback?: () => void) {
        if (this.state.tabIndex !== tabIndex) {
            const routing: any = JSON.parse(JSON.stringify(this.props.routing || {}));
            const tabName: string = this.props.tabsClassName === 'tabs-effizienznetzwerk'
                // ? RoutingIDs.TABS_EFFIZIENZNETZWERK_DOKUMENTENABLAGE_GEBAEUDE
                ? RoutingIDs.TABS_ZUSATZTOOLS_EFFIZIENZNETZWERK_DOKUMENTENABLAGE_GEBAEUDE
                : (this.props.tabsClassName === 'tabs-zusatztools' ? RoutingIDs.TABS_ZUSATZTOOLS_DOKUMENTENABLAGE_GEBAEUDE : undefined);
            if (routing.path && routing.path[tabName] === undefined) {
                // init default tabIndex
                routing.path[tabName] = this.state.tabIndex;
                this.props.onRoutingChange(routing);
            }
            setTimeout(() => {
                this.setState({ tabIndex }, () => {
                    this.props.onRoutingChange(tabRouting);
                    this.contextService.set('tabIdxDateiablageGebaeude', tabIndex);
                    if (typeof callback === 'function') {
                        callback();
                    }
                });
            }, 0);
        }
    }

    render(): JSX.Element {
        const tabRoutings = this.props.tabsClassName === 'tabs-effizienznetzwerk'
            ? buildChildrenEffizienznetzwerkDokumentenablageGebaeude()
            : (this.props.tabsClassName === 'tabs-zusatztools' ? buildChildrenZusatztoolsDokumentenablageGebaeude() : []);

        return (
            <Tabs
                className={this.props.tabsClassName || null}
                style={{ flex: 1, flexDirection: 'column', display: 'flex', minHeight: 0 }}
                selectedIndex={this.state.tabIndex}
                // onSelect={
                //     (tabIndex, lastIndex, event) => this.setState(
                //         { tabIndex },
                //         () => this.contextService.set('tabIdxDateiablageGebaeude', this.state.tabIndex)
                //     )
                // }
                onSelect={(tabIndex, lastIndex, event) => this.setTabIndex(tabIndex, tabRoutings[tabIndex])}
            >
                <TabList style={{ display: 'none' }}>
                    <Tab>{i18n('Planungsunterlagen / Fotos', 'tab')}</Tab>
                    <Tab>{i18n('Statistische Berechnungen / Wärmeschutz', 'tab')}</Tab>
                    <Tab>{i18n('Sanierungen', 'tab')}</Tab>
                    <Tab>{i18n('Zusätzliche Berechnungen / Konzepte', 'tab')}</Tab>
                    <Tab>{i18n('Sonstiges (Gebäude)', 'tab')}</Tab>
                </TabList>
                <TabPanel style={{ flexDirection: 'column', display: 'flex', minHeight: 0, flex: this.state.tabIndex === 0 ? 1 : 0 }}>
                    <DateiablageGalerie
                        data={this.props.data}
                        routing={this.props.routing}
                        onRoutingChange={this.props.onRoutingChange}
                        id={'no_ent_gebaeude_planungsunterlagen'}
                        name={'Planungsunterlagen / Fotos'}
                        viewNotice={this.props.viewNotice}
                    />
                </TabPanel>
                <TabPanel style={{ flexDirection: 'column', display: 'flex', minHeight: 0, flex: this.state.tabIndex === 1 ? 1 : 0 }}>
                    <DateiablageGalerie
                        data={this.props.data}
                        routing={this.props.routing}
                        onRoutingChange={this.props.onRoutingChange}
                        id={'no_ent_gebaeude_statistische_berechnungen'}
                        name={'Statistische Berechnungen / Wärmeschutz'}
                        viewNotice={this.props.viewNotice}
                    />
                </TabPanel>
                <TabPanel style={{ flexDirection: 'column', display: 'flex', minHeight: 0, flex: this.state.tabIndex === 2 ? 1 : 0 }}>
                    <DateiablageGalerie
                        data={this.props.data}
                        routing={this.props.routing}
                        onRoutingChange={this.props.onRoutingChange}
                        id={'no_ent_gebaeude_sanierungen'}
                        name={'Sanierungen'}
                        viewNotice={this.props.viewNotice}
                    />
                </TabPanel>
                <TabPanel style={{ flexDirection: 'column', display: 'flex', minHeight: 0, flex: this.state.tabIndex === 3 ? 1 : 0 }}>
                    <DateiablageGalerie
                        data={this.props.data}
                        routing={this.props.routing}
                        onRoutingChange={this.props.onRoutingChange}
                        id={'no_ent_gebaeude_zusaetzliche_berechnungen'}
                        name={'Zusätzliche Berechnungen / Konzepte'}
                        viewNotice={this.props.viewNotice}
                    />
                </TabPanel>
                <TabPanel style={{ flexDirection: 'column', display: 'flex', minHeight: 0, flex: this.state.tabIndex === 4 ? 1 : 0 }}>
                    <DateiablageGalerie
                        data={this.props.data}
                        routing={this.props.routing}
                        onRoutingChange={this.props.onRoutingChange}
                        id={'no_ent_gebaeude_sonstiges'}
                        name={'Sonstiges (Gebäude)'}
                        viewNotice={this.props.viewNotice}
                    />
                </TabPanel>
            </Tabs>
        );
    }
}
